import Vue from 'vue'
import VueAnalytics from 'vue-analytics'
import Lineliff from '@line/liff'

import router from '@/router'
import store from '@/store'

export function beforeRoute(to, from, _next) {
  return new Promise(resolve => {
    const next = (payload) => resolve(_next(payload))
    
    if (from.name != 'MenuDetail') {
      store.dispatch('setScrollMenuPosition', null)
    }
    
    // 1. Get Alias Restaurant & Branch
    store.dispatch('getAliasDetail', {
      restaurant: to.params.restaurant_uuid,
      branch: to.params.branch_uuid
    }).then((res) => {
  
      if (res) {
        if (typeof(res.restaurant_uuid) !== 'undefined') {
          localStorage.setItem('restaurant', JSON.stringify({
            uuid: res.restaurant_uuid,
            alias: res.restaurant_alias || res.restaurant_uuid
          }))
        }
        if (typeof(res.restaurant_uuid && res.branch_uuid) !== 'undefined') {
          localStorage.setItem('restaurant', JSON.stringify({
            uuid: res.restaurant_uuid,
            alias: res.restaurant_alias || res.restaurant_uuid
          }))
          localStorage.setItem('branch', JSON.stringify({
            uuid: res.branch_uuid,
            alias: res.branch_alias || res.branch_uuid
          }))
        }
  
        const restaurantUUID = JSON.parse(localStorage.getItem('restaurant'))
        const branchUUID = JSON.parse(localStorage.getItem('branch'))
        localStorage.setItem('branchClosed', JSON.stringify({status: false}))
  
        // 2. Get Restaurant Detail
        store.dispatch('getRestaurantDetail', { restaurant_uuid: restaurantUUID.uuid })
          .then(restaurant => {
            const isRestaurantEmpty = Array.isArray(restaurant)
            if (isRestaurantEmpty) return
            if (!restaurant.liff_id) return
            return store.dispatch('initLineLiff', restaurant.liff_id)
          })
        

        if (branchUUID.uuid && branchUUID.alias != '') {

          // 3. Get Branch Detail
          store.dispatch('getBranchDetail', {
            restaurant_uuid: restaurantUUID.uuid,
            branch_uuid: branchUUID.uuid
          }).then((branch) => {
            if (!Array.isArray(branch)) {
  
              // Set Default Cart By Branch
              store.dispatch('setLocalStorageToCart', branch)
              
              // Line Liff
              if (branch.liffId) {
                store.dispatch('loginLineLiff', branch.liffId)
                // const UA = navigator.userAgent || navigator.vendor || window.opera
                // window.liff.init({ liffId: branch.liffId }, () => {
                //   // alert('browser line: ' + isLINE(UA) + ' browser line: ' + window.liff.isInClient())
                //   if(isLINE(UA)) {
                //     if (!window.liff.isLoggedIn()) {
                //       window.liff.login()
                //     }
                //   }
                // }, err => console.error(err.code, error.message))
              }
  
              // Google Analaytics
              if (branch.ga_key != '') {
                Vue.use(VueAnalytics, {
                  id: branch.ga_key,
                  router
                })
              }
  
              // Facebook Pixel
              if (branch.fb_pixel_id != '') {
                window.fbq('init', branch.fb_pixel_id)
                window.fbq('track', 'PageView')
              }
  
              // 4. Get Preorder Detail
              // Redirect Page Follow Setting Preorder
              store.dispatch('getPreorderDetail', {
                restaurant_uuid: restaurantUUID.uuid,
                branch_uuid: branchUUID.uuid
              }).then((preorder) => {
                if (!Array.isArray(preorder)) {
  
                  const displayOnlineFlag = preorder.displayOnlineFlag
                  const receiveOrderFlag = preorder.receiveOrderFlag
                  const preorderFlag = preorder.preOrderSetting.preorderFlag
                  const orderNowFlag = preorder.orderNowSetting.orderNowFlag
                  const deliveryFlag = preorder.deliveryFlag
                  const pickupFlag = preorder.pickupFlag
  
             
                  const areServicesNotOpening = (deliveryFlag == 0 && pickupFlag == 0)
                  const isOrderingNotReady = (!orderNowFlag && !preorderFlag)
                  const isNotReceiveOrder = receiveOrderFlag == 0
                  
                  const isBranchClosing = areServicesNotOpening || isNotReceiveOrder || isOrderingNotReady
  
                  // const isBranchClosing = (displayOnlineFlag == '1' && receiveOrderFlag == '1' && deliveryFlag == '0' && pickupFlag == '0' && preorderFlag && !orderNowFlag) ||
                  //   (displayOnlineFlag == '1' && receiveOrderFlag == '1' && deliveryFlag == '0' && pickupFlag == '0' && !preorderFlag && orderNowFlag) ||
                  //   (displayOnlineFlag == '1' && receiveOrderFlag == '1' && deliveryFlag == '0' && pickupFlag == '0' && preorderFlag && orderNowFlag) ||
                  //   (displayOnlineFlag == '0' && receiveOrderFlag == '0') ||
                  //   (displayOnlineFlag == '1' && receiveOrderFlag == '0')
                  
                  if (to.name == 'RestaurantPage' || to.name == 'PageNotFound' || to.name == 'PageNotReciveOrder') {
                    if (to.name == 'PageNotReciveOrder') {
                      next({ path: `/restaurant/${restaurantUUID.alias}/${branchUUID.alias}/close` })
                    } else {
                      next()
                    }
                  } else {
                    if (isBranchClosing) { // Case 3-8, 72, 74-77
                        localStorage.setItem('branchClosed', JSON.stringify({status: true}))
                        next({ path: `/restaurant/${restaurantUUID.alias}/${branchUUID.alias}/close` })
                    } else if ((displayOnlineFlag == '1' && receiveOrderFlag == '1' && !preorderFlag && !orderNowFlag)) { // Case 1,2,9,10,17,18,25,26
                        next({ name: 'PageNotFound' })
                    } else if (to.name == 'MenuDetail' && !preorder.deliveryTime.isOpen && !preorder.preOrderSetting.preorderFlag && preorder.orderNowSetting.orderNowFlag) {
                      // CASE 7 Phase 3.0 Redirect To MenuList Page
                      if (from.name === null) {
                        // Direct URL
                        next({ path: '/restaurant/' + restaurantUUID.uuid + '/' + branchUUID.uuid })
                      } else {
                        // From Menu List
                        resolve(router.go(0))
                      }
                    } else if (to.name == 'CheckoutCart' && !preorder.deliveryTime.isOpen && !preorder.preOrderSetting.preorderFlag && preorder.orderNowSetting.orderNowFlag) {
                      // CASE 7 Phase 3.0 Redirect To MenuList Page
                      next({ path: '/restaurant/' + restaurantUUID.uuid + '/' + branchUUID.uuid })
                    } else {
                      next()
                    }
                  }
                }
              })
            } else {
              next()
            }
          })
        } else {
          if (to.name == 'RestaurantPage' || to.name == 'PageNotReciveOrder' || to.name == 'PageNotFound') next()
          else next({ name: 'PageNotFound' })
        }
      } else {
        next({ name: 'PageNotFound' })
      }
    })
    if (to.name == 'RestaurantPage' || to.name == 'PageNotReciveOrder' || to.name == 'PageNotFound') next()
    // else next({ name: 'PageNotFound' })
  })
}

export default beforeRoute


// WEBPACK FOOTER //
// ./src/router/beforeRoute.js